var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup172118(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2815",
    "data-name": "Rectangle 2815",
    width: 48,
    height: 48,
    transform: "translate(-0.004)",
    fill: "#5eb0e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172118",
    "data-name": "Group 172118",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172117",
    "data-name": "Group 172117",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4527",
    "data-name": "Path 4527",
    d: "M369.315,382.5h-3.723a.743.743,0,0,1-.739-.662l-.314-2.875a11.76,11.76,0,0,1-3.152-1.311l-2.26,1.815a.743.743,0,0,1-.99-.054l-2.632-2.632a.743.743,0,0,1-.054-.99l1.815-2.26a11.757,11.757,0,0,1-1.311-3.152l-2.875-.314a.743.743,0,0,1-.662-.739V365.6a.743.743,0,0,1,.662-.739l2.875-.314a11.756,11.756,0,0,1,1.311-3.152l-1.815-2.26a.743.743,0,0,1,.054-.99l2.632-2.632a.743.743,0,0,1,.99-.054l2.26,1.815a11.757,11.757,0,0,1,3.152-1.311l.314-2.875a.743.743,0,0,1,.739-.662h3.723a.743.743,0,0,1,.739.662l.314,2.875a11.758,11.758,0,0,1,3.152,1.311l2.26-1.815a.742.742,0,0,1,.99.054l2.632,2.632a.743.743,0,0,1,.054.99l-1.814,2.26a11.758,11.758,0,0,1,1.311,3.152l2.875.314a.743.743,0,0,1,.662.739v3.723a.743.743,0,0,1-.662.739l-2.875.314a11.759,11.759,0,0,1-1.311,3.152l1.814,2.26a.743.743,0,0,1-.054.99l-2.632,2.632a.743.743,0,0,1-.99.054l-2.26-1.815a11.761,11.761,0,0,1-3.152,1.311l-.314,2.875a.743.743,0,0,1-.739.662m-3.057-1.486h2.391l.3-2.739a.742.742,0,0,1,.59-.647,10.275,10.275,0,0,0,3.625-1.507.746.746,0,0,1,.875.04l2.153,1.729,1.69-1.69-1.729-2.153a.743.743,0,0,1-.04-.875,10.276,10.276,0,0,0,1.507-3.625.742.742,0,0,1,.647-.59l2.739-.3v-2.391l-2.739-.3a.742.742,0,0,1-.647-.59,10.276,10.276,0,0,0-1.507-3.625.743.743,0,0,1,.04-.875l1.729-2.153-1.69-1.69-2.153,1.729a.743.743,0,0,1-.875.04,10.276,10.276,0,0,0-3.625-1.507.742.742,0,0,1-.59-.647l-.3-2.739h-2.391l-.3,2.739a.742.742,0,0,1-.59.647,10.276,10.276,0,0,0-3.625,1.507.743.743,0,0,1-.875-.04l-2.153-1.729-1.69,1.69,1.729,2.153a.743.743,0,0,1,.04.875,10.276,10.276,0,0,0-1.507,3.625.742.742,0,0,1-.647.59l-2.739.3v2.391l2.739.3a.742.742,0,0,1,.647.59,10.276,10.276,0,0,0,1.507,3.625.743.743,0,0,1-.04.875l-1.729,2.153,1.69,1.69,2.153-1.729a.746.746,0,0,1,.875-.04,10.275,10.275,0,0,0,3.625,1.507.742.742,0,0,1,.59.647Zm15.491-11.69h0Z",
    transform: "translate(-343.679 -343.684)",
    fill: "#5eb0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4528",
    "data-name": "Path 4528",
    d: "M711.134,717.44a6.3,6.3,0,1,1,6.3-6.3,6.31,6.31,0,0,1-6.3,6.3m0-11.118a4.816,4.816,0,1,0,4.816,4.816,4.822,4.822,0,0,0-4.816-4.816",
    transform: "translate(-687.36 -687.364)",
    fill: "#5eb0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4529",
    "data-name": "Path 4529",
    d: "M1484.571,190.416a.743.743,0,0,1-.743-.743V184.96a.743.743,0,0,1,.743-.743h4.713a.743.743,0,0,1,0,1.486h-3.97v3.97a.742.742,0,0,1-.743.743",
    transform: "translate(-1447.045 -179.651)",
    fill: "#5eb0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4530",
    "data-name": "Path 4530",
    d: "M189.669,1490.03h-4.713a.743.743,0,0,1,0-1.486h3.97v-3.97a.743.743,0,0,1,1.486,0v4.713a.742.742,0,0,1-.743.743",
    transform: "translate(-179.647 -1447.048)",
    fill: "#5eb0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    d: "M929.826,226.948a.743.743,0,1,1,0-1.486A22.289,22.289,0,0,0,943.141,185.3a.743.743,0,0,1,.888-1.191,23.775,23.775,0,0,1-14.2,42.841",
    transform: "translate(-906.052 -179.4)",
    fill: "#5eb0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M10.014,42.993a.738.738,0,0,1-.443-.147A23.775,23.775,0,0,1,23.774.005a.743.743,0,0,1,0,1.486A22.289,22.289,0,0,0,10.459,41.655a.743.743,0,0,1-.445,1.339",
    transform: "translate(0 -0.005)",
    fill: "#5eb0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M1089.863,14.918a.742.742,0,0,1-.282-.059.8.8,0,0,1-.4-.4.743.743,0,0,1-.06-.282.73.73,0,0,1,.223-.527.741.741,0,0,1,.238-.164.759.759,0,0,1,.81.164.748.748,0,0,1,.163.237c.015.045.03.1.045.141a.923.923,0,0,1,.015.149.741.741,0,0,1-.06.282.794.794,0,0,1-.4.4.751.751,0,0,1-.289.059",
    transform: "translate(-1062.122 -13.098)",
    fill: "#5eb0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M771.866,1846.4a.742.742,0,0,1-.527-.223.733.733,0,0,1-.156-.238.744.744,0,0,1-.06-.282.812.812,0,0,1,.06-.29.732.732,0,0,1,.156-.238.887.887,0,0,1,.245-.163.759.759,0,0,1,.81.163.9.9,0,0,1,.164.238.8.8,0,0,1,.052.29.736.736,0,0,1-.052.282.756.756,0,0,1-.164.238.74.74,0,0,1-.527.223",
    transform: "translate(-752.008 -1799.178)",
    fill: "#5eb0e5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup172118);
export default __webpack_public_path__ + "static/media/group-172118.93d1c786accc7bd7fd8a150a9a54c282.svg";
export { ForwardRef as ReactComponent };